import {Dispatch, SetStateAction} from 'react'

export type ID = undefined | null | number

export type PaginationState = {
  page: number
  per_page: 10 | 30 | 50 | 100
  links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
  total?: number
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: unknown
}

export type SearchState = {
  name?: string
  id?: string
  phone?: string
  document?: string
  clientId?: string
  active?: string
}

export type SearchReportsSales = {
  franchises?: string
  seller?: string
  dtStart?: string
  dtEnd?: string
  status?: string
  categories?: string
  types?: string
  items?: string
  contract?: string
  client_name?: string
}

export type SearchReportsUsers = {
  name?: string
  qteContract?: string
  totalSaler?: string
  filter_by_month_year?: string
}

export type SearchReportsClients = {
  name?: string
  document?: string
  phones?: string
  birthDate?: string
  createdAt?: string
  createdAtStart?: string
  createdAtEnd?: string
  gender?: string
  restrict?: string
  others?: string
  contractAtStart?: string
  contractAtEnd?: string
  situationDateStart?: string
  situationDateEnd?: string
}

export type SearchfilterByMonthYear = {
  filterByMonthYear?: string
}

export type SearchReportsRecurrence = {
  constract?: number
  clientName?: string
  amount?: string
  installmentNumber?: string
  dueDateStart?: string
  dueDateEnd?: string
  status?: string
  statusName?: string
}

export type SearchReportsTransfers = {
  clientName?: string
  originFranchiseName?: string
  originSaleId?: number
  destinationFranchiseName?: string
  newSaleId?: number
  status?: string
  requestedUserName?: string
  approvedUserName?: string
  franchiseTransferValue?: string
  clientBillingToOrigin?: string
  clientBillingToDestination?: string
  fineValue?: string
  origin_sale?: string
  new_sale?: string
}

export type SimpleResponse<T> = {
  data?: T
}

export type Response<T> = {
  data?: T
  meta: PaginationState & {
    current_page: number
  }
}

export type QueryState = PaginationState &
  SortState &
  FilterState &
  SearchState &
  SearchReportsSales &
  SearchReportsClients &
  SearchReportsUsers &
  SearchReportsTransfers &
  SearchReportsRecurrence &
  SearchfilterByMonthYear

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export const initialQueryState: QueryState = {
  page: 1,
  per_page: 10,
  total: 0,
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
  hasSearched?: boolean
}

export type TItemForDelete = {
  id: ID
  name: string
}

export const initialQueryResponse = {refetch: () => {}, isLoading: false, query: ''}

export type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>
  itemIdForUpdatePdf?: ID
  setItemIdForUpdatePdf?: Dispatch<SetStateAction<ID>>
  itemIdForUpdateLog?: ID
  setItemIdForUpdateLog?: Dispatch<SetStateAction<ID>>
  paymentLog?: any
  setPaymentLog?: Dispatch<SetStateAction<any>>

  isAllSelected: boolean
  disabled: boolean
  itemForDelete?: TItemForDelete | null
  setItemForDelete?: Dispatch<SetStateAction<TItemForDelete | null | undefined>>
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  setItemIdForUpdatePdf: () => {},
  setItemIdForUpdateLog: () => {},
  setPaymentLog: () => {},
  isAllSelected: false,
  disabled: false,
  itemForDelete: null,
  setItemForDelete: () => {},
}
